import { render, staticRenderFns } from "./LibrisFilter.vue?vue&type=template&id=7835d6e4"
import script from "./LibrisFilter.vue?vue&type=script&lang=js"
export * from "./LibrisFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports